import React from "react";
import { Building, ThumbsUp, Award, CheckCircle } from "lucide-react";
import realEstateImg from "../../Files/About-us-home-first-brickimage.png";

const HomeAboutUs = () => {
    return (
        <section className="hob-aboutus-section">
            <div className="hob-aboutus-container">
                {/* Left Content */}
                <div className="hob-aboutus-left">
                    <h2 className="hob-aboutus-heading">About Sarfare Properties</h2>
                    <p className="hob-aboutus-text">
                        <strong>Sarfare Properties</strong> is a trusted name in Mumbai’s real estate landscape, backed by over 20 years of experience in broking, investment consulting, and full-spectrum property services. We specialize in delivering high-value real estate solutions with a personal touch, helping both residents and NRIs navigate the complexities of the property market with confidence and ease.
                        <br /><br />
                        Our deep-rooted presence in Mumbai gives us unmatched insight into the city’s dynamic real estate trends. Whether you’re looking to buy, sell, invest, or manage property, our team is committed to maximizing your returns through tailored, transparent, and strategic guidance.
                    </p>

                    <ul className="hob-aboutus-list">
                        <li><CheckCircle size={20} /> Property Management for NRIs & Residents</li>
                        <li><CheckCircle size={20} /> Real Estate Investment Consulting</li>
                        <li><CheckCircle size={20} /> Legal & Documentation Services</li>
                        <li><CheckCircle size={20} /> Off-Market Property Deals</li>
                    </ul>
                </div>

                {/* Right Side Image & Stats */}
                <div className="hob-aboutus-right">
                    <div className="hob-aboutus-image-wrapper">
                        <img
                            src={realEstateImg}
                            alt="Luxury Properties"
                            className="hob-aboutus-image"
                        />

                        {/* Floating Stats */}
                        <div className="hob-aboutus-float hob-aboutus-top-right">
                            <div className="hob-aboutus-flex">
                                <Building size={18} />
                                <span>Established 20+</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Years of real estate excellence.
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-bottom-right">
                            <div className="hob-aboutus-flex">
                                <ThumbsUp size={18} />
                                <span>10K+ Clients</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                Serving residents and NRIs with trust.
                            </p>
                        </div>

                        <div className="hob-aboutus-float hob-aboutus-center-float">
                            <div className="hob-aboutus-flex">
                                <Award size={18} />
                                <span>Full-Spectrum Services</span>
                            </div>
                            <p className="hob-aboutus-float-desc">
                                From investments to interiors — we do it all.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeAboutUs;
